import styled from "styled-components";

export const Container = styled.div`
position: relative;
top: 80px;
`;

export const Content = styled.div`
  padding: 0 var(--page-lateral-padding) 4rem;
`;